module.exports = __webpack_public_path__ + "static/media/Snapshot Vid_1723797159692.0dfc17ad. Script 07 2024";